import React from 'react';
import './AboutComponentStyle.scss';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { aboutMainImg } from '../../../assets/imgs/main_about';
import { aboutMainMobileImg } from '../../../assets/imgs/main_about/mobile';

interface Ilinks {
  url: string;
  img: string;
  text: string;
}

const AboutComponent = () => {
  const { t } = useTranslation();
  return (
    <div className="about_component_container">
      {/* desktop imgs */}
      <img id="LeftB" src={aboutMainImg.LeftB} alt="LeftB" />
      <img id="LeftT" src={aboutMainImg.LeftT} alt="LeftT" />
      <img id="RightB" src={aboutMainImg.RightB} alt="RightB" />
      <img id="RightM" src={aboutMainImg.RightM} alt="RightM" />
      <img id="RightT" src={aboutMainImg.RightT} alt="RightT" />
      {/* mobile imgs */}
      <img id="LeftBM" src={aboutMainMobileImg.LeftB} alt="LeftB" />
      <img id="LeftTM" src={aboutMainMobileImg.LeftT} alt="LeftT" />
      <img id="RightBM" src={aboutMainMobileImg.RightB} alt="RightB" />
      <img id="RightTM" src={aboutMainMobileImg.RightT} alt="RightT" />
      <h3>{t('about_page.about_component.title')}</h3>
      <label>{t('about_page.about_component.sub_title')}</label>
      {/* <Link to="/privacy-policy">{t('maim_page.main_about.link')}</Link> */}
    </div>
  );
};

export default AboutComponent;
